import React, { useState } from "react";
import SegmentClient from "clients/SegmentClient";

const PostCodeSearchForm = () => {
  const [postcode, updatePostcode] = useState(null);

  const handlePostcodeChange = event => {
    updatePostcode(event.target.value);
  };

  const fireSegmentEvent = () => {
    SegmentClient.trackEvent({
      event: "sign up - postcode page search",
      eventCatergory: "pre-user activation",
      eventAction: "sign up - postcode page search",
      eventLabel: "submit",
      postcode
    });
  };

  return (
    <div className="postcode_search_form">
      <form
        method="GET"
        action="/postcode-search/"
        _lpchecked="1"
        id="postcode_search_form"
      >
        <input
          type="text"
          id="postcode"
          data-testid="postcode-input"
          placeholder="Enter postcode"
          name="postcode"
          onChange={handlePostcodeChange}
        />
        <button
          type="submit"
          id="postcodeSearchFormButton"
          className="postcodeSearchInput"
          onClick={fireSegmentEvent}
        >
          Find care
        </button>
      </form>
    </div>
  );
};

export default PostCodeSearchForm;
